import jwt_decode from "jwt-decode"
// retrieves session state saved in a JSON Web token
export const GetSession = () => {
    return {
        UserId: GetUserId(),
        UserName: GetUserName(),
        IsMobile: false,
        SiteID: parseInt(GetValue("siteID")),
        CloudID: GetValue("cloudID"),
        CloudURL: GetValue("cloudURL")
    }
}

export const GetValue = (val) => {
    let ui = localStorage.getItem("userid");
    if (ui === null || ui === undefined || ui === "") return "";
    return sessionStorage.getItem(val);
}

export const GetUserId = () => {
    const userId = sessionStorage.getItem("userId");
    if (userId) return userId;
    else return null;
}

export const GetUserName = () => {
    const username = sessionStorage.getItem("userName");
    if (username) return username;
    else return null;
}

export const GetToken = () => {
    const token = sessionStorage.getItem("token");

    if (token) {
        let decodedToken = jwt_decode(token);
        let currentDate = new Date().getTime();

        if (decodedToken.exp * 1000 < currentDate) {
            return null;
        }
        else {
            return token;
        }

    }
    else return null;
}

export const setUserSession = (data) => {
    localStorage.setItem("userid", data.userId);
    sessionStorage.setItem("userName", data.userName);
    sessionStorage.setItem("token", data.token);
    sessionStorage.setItem("userId", data.userId);
    sessionStorage.setItem("usersRole", data.usersRole);
    sessionStorage.setItem("siteID", data.siteID);
    sessionStorage.setItem("cloudURL", data.cloudURL);
    sessionStorage.setItem("cloudID", data.cloudID);
}


export const removeUserSession = (userName, token, userId, usersRole) => {
    localStorage.removeItem("userid");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("usersRole");
}


export const Map = () => { }
export const MapLayers = () => { }
export const MapTileLayer = () => { }
export const MapMarkerLayer = () => { }
